var StraightLineGeneralDataToGoModelUtil = /** @class */ (function () {
    function StraightLineGeneralDataToGoModelUtil(diagram, goModel) {
        this.diagram = diagram;
        this.goModel = goModel;
    }
    StraightLineGeneralDataToGoModelUtil.prototype.saveComponentProperty = function (property, value) {
        this.diagram.model.setDataProperty(this.goModel, property, value);
    };
    StraightLineGeneralDataToGoModelUtil.prototype.saveToGoJsModel = function (data) {
        this.saveComponentProperty('stroke', data.stroke);
        this.saveComponentProperty('strokeWidth', data.strokeWidth);
        this.saveComponentProperty('lineType', data.lineType);
        this.saveComponentProperty('isArrow', data.arrow.isArrow ? data.arrow.isArrow : false);
        if (data.arrow.isArrow) {
            this.saveComponentProperty('arrowStyle', data.arrow.arrowStyle);
        }
        else {
            delete this.goModel.arrowStyle;
        }
    };
    return StraightLineGeneralDataToGoModelUtil;
}());
export { StraightLineGeneralDataToGoModelUtil };
